import { useState } from 'react';
import { Button, Collapse, Group, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronRight, IconSparkles } from '@tabler/icons-react';
import type { Round } from '@flow/core';
import { useAiAvailable, useSummarizeRound } from './useAi';

/** Under a submitted round in the list: its recap (collapsed), or a button to write one. */
export const RoundSummary = ({ round }: { round: Round }) => {
  const ai = useAiAvailable();
  const summarize = useSummarizeRound();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (round.status !== 'submitted') return null;
  if (!round.summary) {
    if (!ai) return null;
    return (
      <Button
        size="compact-xs"
        variant="subtle"
        leftSection={<IconSparkles size={12} />}
        loading={busy}
        onClick={async () => {
          setBusy(true);
          await summarize(round.id);
          setBusy(false);
        }}
        data-testid="summarize"
      >
        Summarize round
      </Button>
    );
  }
  return (
    <div>
      <UnstyledButton onClick={() => setOpen((o) => !o)} aria-expanded={open} data-testid="summary-toggle">
        <Group gap={4}>
          {open ? <IconChevronDown size={12} /> : <IconChevronRight size={12} />}
          <Text size="xs" c="dimmed">Recap</Text>
        </Group>
      </UnstyledButton>
      <Collapse expanded={open}>
        <Text size="sm" style={{ whiteSpace: 'pre-wrap' }} mt={4} data-testid="summary-text">{round.summary.text}</Text>
        <Text size="xs" c="dimmed" mt={4}>AI-written from your flow after you submitted. Debater names are never sent.</Text>
      </Collapse>
    </div>
  );
};
